unit View.Itens_Entrada.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UUtils;

type
  TFViewItens_EntradaList = class(TForm)
    btNew: TButton;
    Itens_EntradaDataset: TXDataWebDataSet;
    Itens_EntradaDatasetid: TIntegerField;
    Itens_EntradaDatasetaliado_id: TIntegerField;
    Itens_EntradaDatasetdata_base_id: TIntegerField;
    Itens_EntradaDatasetcompra_id: TIntegerField;
    Itens_EntradaDatasetitem: TIntegerField;
    Itens_EntradaDatasetproduto_id: TIntegerField;
    Itens_EntradaDatasetgrade_produto_id: TIntegerField;
    Itens_EntradaDatasetproduto_nome: TStringField;
    Itens_EntradaDatasetmovimenta_estoque: TBooleanField;
    Itens_EntradaDatasetestoque_inicial: TFloatField;
    Itens_EntradaDatasetestoque_final: TFloatField;
    Itens_EntradaDatasetcfop_cfop: TStringField;
    Itens_EntradaDatasetunidade_id: TIntegerField;
    Itens_EntradaDatasetquantidade: TFloatField;
    Itens_EntradaDatasetvalor_unitario: TFloatField;
    Itens_EntradaDatasetdesconto: TFloatField;
    Itens_EntradaDatasetvalor_desconto: TFloatField;
    Itens_EntradaDatasetvalor_total: TFloatField;
    Itens_EntradaDatasetvalor_base_icms: TFloatField;
    Itens_EntradaDataseticms: TFloatField;
    Itens_EntradaDatasetvalor_icms: TFloatField;
    Itens_EntradaDataseticms_dif: TFloatField;
    Itens_EntradaDatasetvalor_icms_dif: TFloatField;
    Itens_EntradaDatasetvalor_base_st: TFloatField;
    Itens_EntradaDatasetst: TFloatField;
    Itens_EntradaDatasetvalor_st: TFloatField;
    Itens_EntradaDataseticms_red: TFloatField;
    Itens_EntradaDatasetvalor_icms_red: TFloatField;
    Itens_EntradaDatasetvalor_base_ipi: TFloatField;
    Itens_EntradaDatasetipi: TFloatField;
    Itens_EntradaDatasetvalor_ipi: TFloatField;
    Itens_EntradaDatasetvalor_custo_unitario: TFloatField;
    Itens_EntradaDatasetlote_fabricacao: TStringField;
    Itens_EntradaDatasetdata_fabricacao: TDateTimeField;
    Itens_EntradaDatasetvalidade: TDateTimeField;
    Itens_EntradaDatasetdias_validade: TIntegerField;
    Itens_EntradaDatasetvalor_frete: TFloatField;
    Itens_EntradaDatasetvalor_despensa_acessoria: TFloatField;
    Itens_EntradaDatasetvalor_seguro: TFloatField;
    Itens_EntradaDatasetvalor_outras: TFloatField;
    Itens_EntradaDatasetcst_id: TStringField;
    Itens_EntradaDatasetcst_ipi_id: TStringField;
    Itens_EntradaDatasetcst_pis_id: TStringField;
    Itens_EntradaDatasetcst_cofins_id: TStringField;
    Itens_EntradaDatasetcsosn_id: TStringField;
    Itens_EntradaDatasetorigem_csosn_id: TIntegerField;
    Itens_EntradaDatasetquantidade_selo_ipi: TIntegerField;
    Itens_EntradaDatasetvalor_base_issqn: TFloatField;
    Itens_EntradaDatasetissqn: TFloatField;
    Itens_EntradaDatasetcodigo_issqn: TStringField;
    Itens_EntradaDatasetvalor_issqn: TFloatField;
    Itens_EntradaDatasetvalor_base_pis: TFloatField;
    Itens_EntradaDatasetpis: TFloatField;
    Itens_EntradaDatasetvalor_pis: TFloatField;
    Itens_EntradaDatasetvalor_base_cofins: TFloatField;
    Itens_EntradaDatasetcofins: TFloatField;
    Itens_EntradaDatasetvalor_cofins: TFloatField;
    Itens_EntradaDatasetcodigo_bc_piscofins_id: TIntegerField;
    Itens_EntradaDatasetcodigo_credito_piscofins_id: TIntegerField;
    Itens_EntradaDatasetvalor_base_st_retida: TFloatField;
    Itens_EntradaDatasetst_retida: TFloatField;
    Itens_EntradaDatasetvalor_st_retida: TFloatField;
    Itens_EntradaDatasetvalor_pis_retido: TFloatField;
    Itens_EntradaDatasetvalor_cofins_retido: TFloatField;
    Itens_EntradaDatasetvalor_desconto_nota: TFloatField;
    Itens_EntradaDatasetvalor_total_liquido: TFloatField;
    Itens_EntradaDatasetvalor_total_impostos: TFloatField;
    Itens_EntradaDatasetvalor_frete_por_fora: TFloatField;
    Itens_EntradaDatasetvalor_outras_despesas: TFloatField;
    Itens_EntradaDatasetvalor_preco_custo: TFloatField;
    Itens_EntradaDatasetvalor_preco_venda: TFloatField;
    Itens_EntradaDatasetvalor_icms_desonerado: TFloatField;
    Itens_EntradaDatasetdesoneracao_icms_id: TIntegerField;
    Itens_EntradaDatasetvalor_icms_proprio_st: TFloatField;
    Itens_EntradaDatasetvalor_icms_original: TFloatField;
    Itens_EntradaDatasetplano_contas_contabil_id: TIntegerField;
    Itens_EntradaDatasetcodigo_interno: TIntegerField;
    Itens_EntradaDatasetexcluido: TBooleanField;
    Itens_EntradaDatasetinclusao: TDateTimeField;
    Itens_EntradaDatasetalteracao: TDateTimeField;
    Itens_EntradaDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchChange(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewItens_EntradaList: TFViewItens_EntradaList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewItens_EntradaList }

procedure TFViewItens_EntradaList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewItens_EntradaList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewItens_EntradaList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewItens_EntradaList, AElementID, Result, @AfterCreate);
end;

procedure TFViewItens_EntradaList.edSearchChange(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewItens_EntradaList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewItens_EntradaList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      Itens_EntradaDataset.Connection.Model.DefaultSchema.FindEntityType(Itens_EntradaDataset.EntitySetName),
      Itens_EntradaDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewItens_EntradaList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('itens_entrada', 'active');
  TUtils.SetValorDicionarioClasses('compras_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_compras', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    Itens_EntradaDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewItens_EntradaList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.itens_entrada.list.pagination.info');
  btNew := TButton.Create('view.itens_entrada.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.itens_entrada.list.table');
  cbPageSize := TComboBox.Create('view.itens_entrada.list.cbPageSize');
  edSearch := TEdit.Create('view.itens_entrada.list.search');
  lcPaginator := TListControl.Create('view.itens_entrada.list.pagination');
  Itens_EntradaDataset := TXDataWebDataSet.Create(Self);
  Itens_EntradaDatasetid := TIntegerField.Create(Self);
  Itens_EntradaDatasetaliado_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetdata_base_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetcompra_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetitem := TIntegerField.Create(Self);
  Itens_EntradaDatasetproduto_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetgrade_produto_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetproduto_nome := TStringField.Create(Self);
  Itens_EntradaDatasetmovimenta_estoque := TBooleanField.Create(Self);
  Itens_EntradaDatasetestoque_inicial := TFloatField.Create(Self);
  Itens_EntradaDatasetestoque_final := TFloatField.Create(Self);
  Itens_EntradaDatasetcfop_cfop := TStringField.Create(Self);
  Itens_EntradaDatasetunidade_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetquantidade := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_unitario := TFloatField.Create(Self);
  Itens_EntradaDatasetdesconto := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_desconto := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_total := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_base_icms := TFloatField.Create(Self);
  Itens_EntradaDataseticms := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_icms := TFloatField.Create(Self);
  Itens_EntradaDataseticms_dif := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_icms_dif := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_base_st := TFloatField.Create(Self);
  Itens_EntradaDatasetst := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_st := TFloatField.Create(Self);
  Itens_EntradaDataseticms_red := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_icms_red := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_base_ipi := TFloatField.Create(Self);
  Itens_EntradaDatasetipi := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_ipi := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_custo_unitario := TFloatField.Create(Self);
  Itens_EntradaDatasetlote_fabricacao := TStringField.Create(Self);
  Itens_EntradaDatasetdata_fabricacao := TDateTimeField.Create(Self);
  Itens_EntradaDatasetvalidade := TDateTimeField.Create(Self);
  Itens_EntradaDatasetdias_validade := TIntegerField.Create(Self);
  Itens_EntradaDatasetvalor_frete := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_despensa_acessoria := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_seguro := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_outras := TFloatField.Create(Self);
  Itens_EntradaDatasetcst_id := TStringField.Create(Self);
  Itens_EntradaDatasetcst_ipi_id := TStringField.Create(Self);
  Itens_EntradaDatasetcst_pis_id := TStringField.Create(Self);
  Itens_EntradaDatasetcst_cofins_id := TStringField.Create(Self);
  Itens_EntradaDatasetcsosn_id := TStringField.Create(Self);
  Itens_EntradaDatasetorigem_csosn_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetquantidade_selo_ipi := TIntegerField.Create(Self);
  Itens_EntradaDatasetvalor_base_issqn := TFloatField.Create(Self);
  Itens_EntradaDatasetissqn := TFloatField.Create(Self);
  Itens_EntradaDatasetcodigo_issqn := TStringField.Create(Self);
  Itens_EntradaDatasetvalor_issqn := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_base_pis := TFloatField.Create(Self);
  Itens_EntradaDatasetpis := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_pis := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_base_cofins := TFloatField.Create(Self);
  Itens_EntradaDatasetcofins := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_cofins := TFloatField.Create(Self);
  Itens_EntradaDatasetcodigo_bc_piscofins_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetcodigo_credito_piscofins_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetvalor_base_st_retida := TFloatField.Create(Self);
  Itens_EntradaDatasetst_retida := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_st_retida := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_pis_retido := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_cofins_retido := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_desconto_nota := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_total_liquido := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_total_impostos := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_frete_por_fora := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_outras_despesas := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_preco_custo := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_preco_venda := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_icms_desonerado := TFloatField.Create(Self);
  Itens_EntradaDatasetdesoneracao_icms_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetvalor_icms_proprio_st := TFloatField.Create(Self);
  Itens_EntradaDatasetvalor_icms_original := TFloatField.Create(Self);
  Itens_EntradaDatasetplano_contas_contabil_id := TIntegerField.Create(Self);
  Itens_EntradaDatasetcodigo_interno := TIntegerField.Create(Self);
  Itens_EntradaDatasetexcluido := TBooleanField.Create(Self);
  Itens_EntradaDatasetinclusao := TDateTimeField.Create(Self);
  Itens_EntradaDatasetalteracao := TDateTimeField.Create(Self);
  Itens_EntradaDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  Itens_EntradaDataset.BeforeLoadDFMValues;
  Itens_EntradaDatasetid.BeforeLoadDFMValues;
  Itens_EntradaDatasetaliado_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetdata_base_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetcompra_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetitem.BeforeLoadDFMValues;
  Itens_EntradaDatasetproduto_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetgrade_produto_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetproduto_nome.BeforeLoadDFMValues;
  Itens_EntradaDatasetmovimenta_estoque.BeforeLoadDFMValues;
  Itens_EntradaDatasetestoque_inicial.BeforeLoadDFMValues;
  Itens_EntradaDatasetestoque_final.BeforeLoadDFMValues;
  Itens_EntradaDatasetcfop_cfop.BeforeLoadDFMValues;
  Itens_EntradaDatasetunidade_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetquantidade.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_unitario.BeforeLoadDFMValues;
  Itens_EntradaDatasetdesconto.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_desconto.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_total.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_base_icms.BeforeLoadDFMValues;
  Itens_EntradaDataseticms.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_icms.BeforeLoadDFMValues;
  Itens_EntradaDataseticms_dif.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_icms_dif.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_base_st.BeforeLoadDFMValues;
  Itens_EntradaDatasetst.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_st.BeforeLoadDFMValues;
  Itens_EntradaDataseticms_red.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_icms_red.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_base_ipi.BeforeLoadDFMValues;
  Itens_EntradaDatasetipi.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_ipi.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_custo_unitario.BeforeLoadDFMValues;
  Itens_EntradaDatasetlote_fabricacao.BeforeLoadDFMValues;
  Itens_EntradaDatasetdata_fabricacao.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalidade.BeforeLoadDFMValues;
  Itens_EntradaDatasetdias_validade.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_frete.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_despensa_acessoria.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_seguro.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_outras.BeforeLoadDFMValues;
  Itens_EntradaDatasetcst_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetcst_ipi_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetcst_pis_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetcst_cofins_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetcsosn_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetorigem_csosn_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetquantidade_selo_ipi.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_base_issqn.BeforeLoadDFMValues;
  Itens_EntradaDatasetissqn.BeforeLoadDFMValues;
  Itens_EntradaDatasetcodigo_issqn.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_issqn.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_base_pis.BeforeLoadDFMValues;
  Itens_EntradaDatasetpis.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_pis.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_base_cofins.BeforeLoadDFMValues;
  Itens_EntradaDatasetcofins.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_cofins.BeforeLoadDFMValues;
  Itens_EntradaDatasetcodigo_bc_piscofins_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetcodigo_credito_piscofins_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_base_st_retida.BeforeLoadDFMValues;
  Itens_EntradaDatasetst_retida.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_st_retida.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_pis_retido.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_cofins_retido.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_desconto_nota.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_total_liquido.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_total_impostos.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_frete_por_fora.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_outras_despesas.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_preco_custo.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_preco_venda.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_icms_desonerado.BeforeLoadDFMValues;
  Itens_EntradaDatasetdesoneracao_icms_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_icms_proprio_st.BeforeLoadDFMValues;
  Itens_EntradaDatasetvalor_icms_original.BeforeLoadDFMValues;
  Itens_EntradaDatasetplano_contas_contabil_id.BeforeLoadDFMValues;
  Itens_EntradaDatasetcodigo_interno.BeforeLoadDFMValues;
  Itens_EntradaDatasetexcluido.BeforeLoadDFMValues;
  Itens_EntradaDatasetinclusao.BeforeLoadDFMValues;
  Itens_EntradaDatasetalteracao.BeforeLoadDFMValues;
  Itens_EntradaDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  try
    Name := 'FViewItens_EntradaList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'compra_id';
      Title := 'compra_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'item';
      Title := 'item';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'produto_id';
      Title := 'produto_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'grade_produto_id';
      Title := 'grade_produto_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'produto_nome';
      Title := 'produto_nome';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'movimenta_estoque';
      Title := 'movimenta_estoque';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'estoque_inicial';
      Title := 'estoque_inicial';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'estoque_final';
      Title := 'estoque_final';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cfop_cfop';
      Title := 'cfop_cfop';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'unidade_id';
      Title := 'unidade_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'quantidade';
      Title := 'quantidade';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_unitario';
      Title := 'valor_unitario';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'desconto';
      Title := 'desconto';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_desconto';
      Title := 'valor_desconto';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_total';
      Title := 'valor_total';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_icms';
      Title := 'valor_base_icms';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'icms';
      Title := 'icms';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms';
      Title := 'valor_icms';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'icms_dif';
      Title := 'icms_dif';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_dif';
      Title := 'valor_icms_dif';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_st';
      Title := 'valor_base_st';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'st';
      Title := 'st';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_st';
      Title := 'valor_st';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'icms_red';
      Title := 'icms_red';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_red';
      Title := 'valor_icms_red';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_ipi';
      Title := 'valor_base_ipi';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'ipi';
      Title := 'ipi';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_ipi';
      Title := 'valor_ipi';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_custo_unitario';
      Title := 'valor_custo_unitario';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'lote_fabricacao';
      Title := 'lote_fabricacao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_fabricacao';
      Title := 'data_fabricacao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'validade';
      Title := 'validade';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'dias_validade';
      Title := 'dias_validade';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_frete';
      Title := 'valor_frete';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_despensa_acessoria';
      Title := 'valor_despensa_acessoria';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_seguro';
      Title := 'valor_seguro';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_outras';
      Title := 'valor_outras';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cst_id';
      Title := 'cst_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cst_ipi_id';
      Title := 'cst_ipi_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cst_pis_id';
      Title := 'cst_pis_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cst_cofins_id';
      Title := 'cst_cofins_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'csosn_id';
      Title := 'csosn_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'origem_csosn_id';
      Title := 'origem_csosn_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'quantidade_selo_ipi';
      Title := 'quantidade_selo_ipi';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_issqn';
      Title := 'valor_base_issqn';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'issqn';
      Title := 'issqn';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_issqn';
      Title := 'codigo_issqn';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_issqn';
      Title := 'valor_issqn';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_pis';
      Title := 'valor_base_pis';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'pis';
      Title := 'pis';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_pis';
      Title := 'valor_pis';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_cofins';
      Title := 'valor_base_cofins';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cofins';
      Title := 'cofins';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_cofins';
      Title := 'valor_cofins';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_bc_piscofins_id';
      Title := 'codigo_bc_piscofins_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_credito_piscofins_id';
      Title := 'codigo_credito_piscofins_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_base_st_retida';
      Title := 'valor_base_st_retida';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'st_retida';
      Title := 'st_retida';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_st_retida';
      Title := 'valor_st_retida';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_pis_retido';
      Title := 'valor_pis_retido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_cofins_retido';
      Title := 'valor_cofins_retido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_desconto_nota';
      Title := 'valor_desconto_nota';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_total_liquido';
      Title := 'valor_total_liquido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_total_impostos';
      Title := 'valor_total_impostos';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_frete_por_fora';
      Title := 'valor_frete_por_fora';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_outras_despesas';
      Title := 'valor_outras_despesas';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_preco_custo';
      Title := 'valor_preco_custo';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_preco_venda';
      Title := 'valor_preco_venda';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_desonerado';
      Title := 'valor_icms_desonerado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'desoneracao_icms_id';
      Title := 'desoneracao_icms_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_proprio_st';
      Title := 'valor_icms_proprio_st';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_icms_original';
      Title := 'valor_icms_original';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'plano_contas_contabil_id';
      Title := 'plano_contas_contabil_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnChange', 'edSearchChange');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    Itens_EntradaDataset.SetParentComponent(Self);
    Itens_EntradaDataset.Name := 'Itens_EntradaDataset';
    Itens_EntradaDataset.EntitySetName := 'Itens_Entrada';
    Itens_EntradaDataset.Connection := DMConnection.ApiConnection;
    Itens_EntradaDataset.Left := 72;
    Itens_EntradaDataset.Top := 144;
    Itens_EntradaDatasetid.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetid.Name := 'Itens_EntradaDatasetid';
    Itens_EntradaDatasetid.FieldName := 'id';
    Itens_EntradaDatasetid.Required := True;
    Itens_EntradaDatasetaliado_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetaliado_id.Name := 'Itens_EntradaDatasetaliado_id';
    Itens_EntradaDatasetaliado_id.FieldName := 'aliado_id';
    Itens_EntradaDatasetaliado_id.Required := True;
    Itens_EntradaDatasetdata_base_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetdata_base_id.Name := 'Itens_EntradaDatasetdata_base_id';
    Itens_EntradaDatasetdata_base_id.FieldName := 'data_base_id';
    Itens_EntradaDatasetdata_base_id.Required := True;
    Itens_EntradaDatasetcompra_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcompra_id.Name := 'Itens_EntradaDatasetcompra_id';
    Itens_EntradaDatasetcompra_id.FieldName := 'compra_id';
    Itens_EntradaDatasetcompra_id.Required := True;
    Itens_EntradaDatasetitem.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetitem.Name := 'Itens_EntradaDatasetitem';
    Itens_EntradaDatasetitem.FieldName := 'item';
    Itens_EntradaDatasetproduto_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetproduto_id.Name := 'Itens_EntradaDatasetproduto_id';
    Itens_EntradaDatasetproduto_id.FieldName := 'produto_id';
    Itens_EntradaDatasetproduto_id.Required := True;
    Itens_EntradaDatasetgrade_produto_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetgrade_produto_id.Name := 'Itens_EntradaDatasetgrade_produto_id';
    Itens_EntradaDatasetgrade_produto_id.FieldName := 'grade_produto_id';
    Itens_EntradaDatasetproduto_nome.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetproduto_nome.Name := 'Itens_EntradaDatasetproduto_nome';
    Itens_EntradaDatasetproduto_nome.FieldName := 'produto_nome';
    Itens_EntradaDatasetproduto_nome.Size := 255;
    Itens_EntradaDatasetmovimenta_estoque.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetmovimenta_estoque.Name := 'Itens_EntradaDatasetmovimenta_estoque';
    Itens_EntradaDatasetmovimenta_estoque.FieldName := 'movimenta_estoque';
    Itens_EntradaDatasetmovimenta_estoque.Required := True;
    Itens_EntradaDatasetestoque_inicial.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetestoque_inicial.Name := 'Itens_EntradaDatasetestoque_inicial';
    Itens_EntradaDatasetestoque_inicial.FieldName := 'estoque_inicial';
    Itens_EntradaDatasetestoque_final.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetestoque_final.Name := 'Itens_EntradaDatasetestoque_final';
    Itens_EntradaDatasetestoque_final.FieldName := 'estoque_final';
    Itens_EntradaDatasetcfop_cfop.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcfop_cfop.Name := 'Itens_EntradaDatasetcfop_cfop';
    Itens_EntradaDatasetcfop_cfop.FieldName := 'cfop_cfop';
    Itens_EntradaDatasetcfop_cfop.Required := True;
    Itens_EntradaDatasetcfop_cfop.Size := 255;
    Itens_EntradaDatasetunidade_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetunidade_id.Name := 'Itens_EntradaDatasetunidade_id';
    Itens_EntradaDatasetunidade_id.FieldName := 'unidade_id';
    Itens_EntradaDatasetunidade_id.Required := True;
    Itens_EntradaDatasetquantidade.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetquantidade.Name := 'Itens_EntradaDatasetquantidade';
    Itens_EntradaDatasetquantidade.FieldName := 'quantidade';
    Itens_EntradaDatasetquantidade.Required := True;
    Itens_EntradaDatasetvalor_unitario.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_unitario.Name := 'Itens_EntradaDatasetvalor_unitario';
    Itens_EntradaDatasetvalor_unitario.FieldName := 'valor_unitario';
    Itens_EntradaDatasetvalor_unitario.Required := True;
    Itens_EntradaDatasetdesconto.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetdesconto.Name := 'Itens_EntradaDatasetdesconto';
    Itens_EntradaDatasetdesconto.FieldName := 'desconto';
    Itens_EntradaDatasetvalor_desconto.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_desconto.Name := 'Itens_EntradaDatasetvalor_desconto';
    Itens_EntradaDatasetvalor_desconto.FieldName := 'valor_desconto';
    Itens_EntradaDatasetvalor_total.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_total.Name := 'Itens_EntradaDatasetvalor_total';
    Itens_EntradaDatasetvalor_total.FieldName := 'valor_total';
    Itens_EntradaDatasetvalor_total.Required := True;
    Itens_EntradaDatasetvalor_base_icms.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_base_icms.Name := 'Itens_EntradaDatasetvalor_base_icms';
    Itens_EntradaDatasetvalor_base_icms.FieldName := 'valor_base_icms';
    Itens_EntradaDataseticms.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDataseticms.Name := 'Itens_EntradaDataseticms';
    Itens_EntradaDataseticms.FieldName := 'icms';
    Itens_EntradaDataseticms.Required := True;
    Itens_EntradaDatasetvalor_icms.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_icms.Name := 'Itens_EntradaDatasetvalor_icms';
    Itens_EntradaDatasetvalor_icms.FieldName := 'valor_icms';
    Itens_EntradaDataseticms_dif.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDataseticms_dif.Name := 'Itens_EntradaDataseticms_dif';
    Itens_EntradaDataseticms_dif.FieldName := 'icms_dif';
    Itens_EntradaDatasetvalor_icms_dif.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_icms_dif.Name := 'Itens_EntradaDatasetvalor_icms_dif';
    Itens_EntradaDatasetvalor_icms_dif.FieldName := 'valor_icms_dif';
    Itens_EntradaDatasetvalor_base_st.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_base_st.Name := 'Itens_EntradaDatasetvalor_base_st';
    Itens_EntradaDatasetvalor_base_st.FieldName := 'valor_base_st';
    Itens_EntradaDatasetst.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetst.Name := 'Itens_EntradaDatasetst';
    Itens_EntradaDatasetst.FieldName := 'st';
    Itens_EntradaDatasetvalor_st.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_st.Name := 'Itens_EntradaDatasetvalor_st';
    Itens_EntradaDatasetvalor_st.FieldName := 'valor_st';
    Itens_EntradaDataseticms_red.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDataseticms_red.Name := 'Itens_EntradaDataseticms_red';
    Itens_EntradaDataseticms_red.FieldName := 'icms_red';
    Itens_EntradaDatasetvalor_icms_red.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_icms_red.Name := 'Itens_EntradaDatasetvalor_icms_red';
    Itens_EntradaDatasetvalor_icms_red.FieldName := 'valor_icms_red';
    Itens_EntradaDatasetvalor_base_ipi.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_base_ipi.Name := 'Itens_EntradaDatasetvalor_base_ipi';
    Itens_EntradaDatasetvalor_base_ipi.FieldName := 'valor_base_ipi';
    Itens_EntradaDatasetipi.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetipi.Name := 'Itens_EntradaDatasetipi';
    Itens_EntradaDatasetipi.FieldName := 'ipi';
    Itens_EntradaDatasetvalor_ipi.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_ipi.Name := 'Itens_EntradaDatasetvalor_ipi';
    Itens_EntradaDatasetvalor_ipi.FieldName := 'valor_ipi';
    Itens_EntradaDatasetvalor_custo_unitario.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_custo_unitario.Name := 'Itens_EntradaDatasetvalor_custo_unitario';
    Itens_EntradaDatasetvalor_custo_unitario.FieldName := 'valor_custo_unitario';
    Itens_EntradaDatasetlote_fabricacao.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetlote_fabricacao.Name := 'Itens_EntradaDatasetlote_fabricacao';
    Itens_EntradaDatasetlote_fabricacao.FieldName := 'lote_fabricacao';
    Itens_EntradaDatasetlote_fabricacao.Size := 255;
    Itens_EntradaDatasetdata_fabricacao.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetdata_fabricacao.Name := 'Itens_EntradaDatasetdata_fabricacao';
    Itens_EntradaDatasetdata_fabricacao.FieldName := 'data_fabricacao';
    Itens_EntradaDatasetvalidade.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalidade.Name := 'Itens_EntradaDatasetvalidade';
    Itens_EntradaDatasetvalidade.FieldName := 'validade';
    Itens_EntradaDatasetdias_validade.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetdias_validade.Name := 'Itens_EntradaDatasetdias_validade';
    Itens_EntradaDatasetdias_validade.FieldName := 'dias_validade';
    Itens_EntradaDatasetvalor_frete.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_frete.Name := 'Itens_EntradaDatasetvalor_frete';
    Itens_EntradaDatasetvalor_frete.FieldName := 'valor_frete';
    Itens_EntradaDatasetvalor_despensa_acessoria.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_despensa_acessoria.Name := 'Itens_EntradaDatasetvalor_despensa_acessoria';
    Itens_EntradaDatasetvalor_despensa_acessoria.FieldName := 'valor_despensa_acessoria';
    Itens_EntradaDatasetvalor_seguro.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_seguro.Name := 'Itens_EntradaDatasetvalor_seguro';
    Itens_EntradaDatasetvalor_seguro.FieldName := 'valor_seguro';
    Itens_EntradaDatasetvalor_outras.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_outras.Name := 'Itens_EntradaDatasetvalor_outras';
    Itens_EntradaDatasetvalor_outras.FieldName := 'valor_outras';
    Itens_EntradaDatasetcst_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcst_id.Name := 'Itens_EntradaDatasetcst_id';
    Itens_EntradaDatasetcst_id.FieldName := 'cst_id';
    Itens_EntradaDatasetcst_id.Size := 255;
    Itens_EntradaDatasetcst_ipi_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcst_ipi_id.Name := 'Itens_EntradaDatasetcst_ipi_id';
    Itens_EntradaDatasetcst_ipi_id.FieldName := 'cst_ipi_id';
    Itens_EntradaDatasetcst_ipi_id.Size := 255;
    Itens_EntradaDatasetcst_pis_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcst_pis_id.Name := 'Itens_EntradaDatasetcst_pis_id';
    Itens_EntradaDatasetcst_pis_id.FieldName := 'cst_pis_id';
    Itens_EntradaDatasetcst_pis_id.Size := 255;
    Itens_EntradaDatasetcst_cofins_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcst_cofins_id.Name := 'Itens_EntradaDatasetcst_cofins_id';
    Itens_EntradaDatasetcst_cofins_id.FieldName := 'cst_cofins_id';
    Itens_EntradaDatasetcst_cofins_id.Size := 255;
    Itens_EntradaDatasetcsosn_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcsosn_id.Name := 'Itens_EntradaDatasetcsosn_id';
    Itens_EntradaDatasetcsosn_id.FieldName := 'csosn_id';
    Itens_EntradaDatasetcsosn_id.Size := 255;
    Itens_EntradaDatasetorigem_csosn_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetorigem_csosn_id.Name := 'Itens_EntradaDatasetorigem_csosn_id';
    Itens_EntradaDatasetorigem_csosn_id.FieldName := 'origem_csosn_id';
    Itens_EntradaDatasetorigem_csosn_id.Required := True;
    Itens_EntradaDatasetquantidade_selo_ipi.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetquantidade_selo_ipi.Name := 'Itens_EntradaDatasetquantidade_selo_ipi';
    Itens_EntradaDatasetquantidade_selo_ipi.FieldName := 'quantidade_selo_ipi';
    Itens_EntradaDatasetvalor_base_issqn.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_base_issqn.Name := 'Itens_EntradaDatasetvalor_base_issqn';
    Itens_EntradaDatasetvalor_base_issqn.FieldName := 'valor_base_issqn';
    Itens_EntradaDatasetissqn.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetissqn.Name := 'Itens_EntradaDatasetissqn';
    Itens_EntradaDatasetissqn.FieldName := 'issqn';
    Itens_EntradaDatasetcodigo_issqn.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcodigo_issqn.Name := 'Itens_EntradaDatasetcodigo_issqn';
    Itens_EntradaDatasetcodigo_issqn.FieldName := 'codigo_issqn';
    Itens_EntradaDatasetcodigo_issqn.Size := 255;
    Itens_EntradaDatasetvalor_issqn.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_issqn.Name := 'Itens_EntradaDatasetvalor_issqn';
    Itens_EntradaDatasetvalor_issqn.FieldName := 'valor_issqn';
    Itens_EntradaDatasetvalor_base_pis.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_base_pis.Name := 'Itens_EntradaDatasetvalor_base_pis';
    Itens_EntradaDatasetvalor_base_pis.FieldName := 'valor_base_pis';
    Itens_EntradaDatasetpis.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetpis.Name := 'Itens_EntradaDatasetpis';
    Itens_EntradaDatasetpis.FieldName := 'pis';
    Itens_EntradaDatasetvalor_pis.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_pis.Name := 'Itens_EntradaDatasetvalor_pis';
    Itens_EntradaDatasetvalor_pis.FieldName := 'valor_pis';
    Itens_EntradaDatasetvalor_base_cofins.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_base_cofins.Name := 'Itens_EntradaDatasetvalor_base_cofins';
    Itens_EntradaDatasetvalor_base_cofins.FieldName := 'valor_base_cofins';
    Itens_EntradaDatasetcofins.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcofins.Name := 'Itens_EntradaDatasetcofins';
    Itens_EntradaDatasetcofins.FieldName := 'cofins';
    Itens_EntradaDatasetvalor_cofins.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_cofins.Name := 'Itens_EntradaDatasetvalor_cofins';
    Itens_EntradaDatasetvalor_cofins.FieldName := 'valor_cofins';
    Itens_EntradaDatasetcodigo_bc_piscofins_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcodigo_bc_piscofins_id.Name := 'Itens_EntradaDatasetcodigo_bc_piscofins_id';
    Itens_EntradaDatasetcodigo_bc_piscofins_id.FieldName := 'codigo_bc_piscofins_id';
    Itens_EntradaDatasetcodigo_credito_piscofins_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcodigo_credito_piscofins_id.Name := 'Itens_EntradaDatasetcodigo_credito_piscofins_id';
    Itens_EntradaDatasetcodigo_credito_piscofins_id.FieldName := 'codigo_credito_piscofins_id';
    Itens_EntradaDatasetvalor_base_st_retida.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_base_st_retida.Name := 'Itens_EntradaDatasetvalor_base_st_retida';
    Itens_EntradaDatasetvalor_base_st_retida.FieldName := 'valor_base_st_retida';
    Itens_EntradaDatasetst_retida.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetst_retida.Name := 'Itens_EntradaDatasetst_retida';
    Itens_EntradaDatasetst_retida.FieldName := 'st_retida';
    Itens_EntradaDatasetvalor_st_retida.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_st_retida.Name := 'Itens_EntradaDatasetvalor_st_retida';
    Itens_EntradaDatasetvalor_st_retida.FieldName := 'valor_st_retida';
    Itens_EntradaDatasetvalor_pis_retido.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_pis_retido.Name := 'Itens_EntradaDatasetvalor_pis_retido';
    Itens_EntradaDatasetvalor_pis_retido.FieldName := 'valor_pis_retido';
    Itens_EntradaDatasetvalor_cofins_retido.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_cofins_retido.Name := 'Itens_EntradaDatasetvalor_cofins_retido';
    Itens_EntradaDatasetvalor_cofins_retido.FieldName := 'valor_cofins_retido';
    Itens_EntradaDatasetvalor_desconto_nota.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_desconto_nota.Name := 'Itens_EntradaDatasetvalor_desconto_nota';
    Itens_EntradaDatasetvalor_desconto_nota.FieldName := 'valor_desconto_nota';
    Itens_EntradaDatasetvalor_total_liquido.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_total_liquido.Name := 'Itens_EntradaDatasetvalor_total_liquido';
    Itens_EntradaDatasetvalor_total_liquido.FieldName := 'valor_total_liquido';
    Itens_EntradaDatasetvalor_total_impostos.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_total_impostos.Name := 'Itens_EntradaDatasetvalor_total_impostos';
    Itens_EntradaDatasetvalor_total_impostos.FieldName := 'valor_total_impostos';
    Itens_EntradaDatasetvalor_frete_por_fora.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_frete_por_fora.Name := 'Itens_EntradaDatasetvalor_frete_por_fora';
    Itens_EntradaDatasetvalor_frete_por_fora.FieldName := 'valor_frete_por_fora';
    Itens_EntradaDatasetvalor_outras_despesas.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_outras_despesas.Name := 'Itens_EntradaDatasetvalor_outras_despesas';
    Itens_EntradaDatasetvalor_outras_despesas.FieldName := 'valor_outras_despesas';
    Itens_EntradaDatasetvalor_preco_custo.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_preco_custo.Name := 'Itens_EntradaDatasetvalor_preco_custo';
    Itens_EntradaDatasetvalor_preco_custo.FieldName := 'valor_preco_custo';
    Itens_EntradaDatasetvalor_preco_venda.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_preco_venda.Name := 'Itens_EntradaDatasetvalor_preco_venda';
    Itens_EntradaDatasetvalor_preco_venda.FieldName := 'valor_preco_venda';
    Itens_EntradaDatasetvalor_icms_desonerado.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_icms_desonerado.Name := 'Itens_EntradaDatasetvalor_icms_desonerado';
    Itens_EntradaDatasetvalor_icms_desonerado.FieldName := 'valor_icms_desonerado';
    Itens_EntradaDatasetdesoneracao_icms_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetdesoneracao_icms_id.Name := 'Itens_EntradaDatasetdesoneracao_icms_id';
    Itens_EntradaDatasetdesoneracao_icms_id.FieldName := 'desoneracao_icms_id';
    Itens_EntradaDatasetvalor_icms_proprio_st.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_icms_proprio_st.Name := 'Itens_EntradaDatasetvalor_icms_proprio_st';
    Itens_EntradaDatasetvalor_icms_proprio_st.FieldName := 'valor_icms_proprio_st';
    Itens_EntradaDatasetvalor_icms_original.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetvalor_icms_original.Name := 'Itens_EntradaDatasetvalor_icms_original';
    Itens_EntradaDatasetvalor_icms_original.FieldName := 'valor_icms_original';
    Itens_EntradaDatasetplano_contas_contabil_id.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetplano_contas_contabil_id.Name := 'Itens_EntradaDatasetplano_contas_contabil_id';
    Itens_EntradaDatasetplano_contas_contabil_id.FieldName := 'plano_contas_contabil_id';
    Itens_EntradaDatasetcodigo_interno.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetcodigo_interno.Name := 'Itens_EntradaDatasetcodigo_interno';
    Itens_EntradaDatasetcodigo_interno.FieldName := 'codigo_interno';
    Itens_EntradaDatasetcodigo_interno.Required := True;
    Itens_EntradaDatasetexcluido.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetexcluido.Name := 'Itens_EntradaDatasetexcluido';
    Itens_EntradaDatasetexcluido.FieldName := 'excluido';
    Itens_EntradaDatasetinclusao.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetinclusao.Name := 'Itens_EntradaDatasetinclusao';
    Itens_EntradaDatasetinclusao.FieldName := 'inclusao';
    Itens_EntradaDatasetalteracao.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetalteracao.Name := 'Itens_EntradaDatasetalteracao';
    Itens_EntradaDatasetalteracao.FieldName := 'alteracao';
    Itens_EntradaDatasetexclusao.SetParentComponent(Itens_EntradaDataset);
    Itens_EntradaDatasetexclusao.Name := 'Itens_EntradaDatasetexclusao';
    Itens_EntradaDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := Itens_EntradaDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    Itens_EntradaDataset.AfterLoadDFMValues;
    Itens_EntradaDatasetid.AfterLoadDFMValues;
    Itens_EntradaDatasetaliado_id.AfterLoadDFMValues;
    Itens_EntradaDatasetdata_base_id.AfterLoadDFMValues;
    Itens_EntradaDatasetcompra_id.AfterLoadDFMValues;
    Itens_EntradaDatasetitem.AfterLoadDFMValues;
    Itens_EntradaDatasetproduto_id.AfterLoadDFMValues;
    Itens_EntradaDatasetgrade_produto_id.AfterLoadDFMValues;
    Itens_EntradaDatasetproduto_nome.AfterLoadDFMValues;
    Itens_EntradaDatasetmovimenta_estoque.AfterLoadDFMValues;
    Itens_EntradaDatasetestoque_inicial.AfterLoadDFMValues;
    Itens_EntradaDatasetestoque_final.AfterLoadDFMValues;
    Itens_EntradaDatasetcfop_cfop.AfterLoadDFMValues;
    Itens_EntradaDatasetunidade_id.AfterLoadDFMValues;
    Itens_EntradaDatasetquantidade.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_unitario.AfterLoadDFMValues;
    Itens_EntradaDatasetdesconto.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_desconto.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_total.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_base_icms.AfterLoadDFMValues;
    Itens_EntradaDataseticms.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_icms.AfterLoadDFMValues;
    Itens_EntradaDataseticms_dif.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_icms_dif.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_base_st.AfterLoadDFMValues;
    Itens_EntradaDatasetst.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_st.AfterLoadDFMValues;
    Itens_EntradaDataseticms_red.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_icms_red.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_base_ipi.AfterLoadDFMValues;
    Itens_EntradaDatasetipi.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_ipi.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_custo_unitario.AfterLoadDFMValues;
    Itens_EntradaDatasetlote_fabricacao.AfterLoadDFMValues;
    Itens_EntradaDatasetdata_fabricacao.AfterLoadDFMValues;
    Itens_EntradaDatasetvalidade.AfterLoadDFMValues;
    Itens_EntradaDatasetdias_validade.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_frete.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_despensa_acessoria.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_seguro.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_outras.AfterLoadDFMValues;
    Itens_EntradaDatasetcst_id.AfterLoadDFMValues;
    Itens_EntradaDatasetcst_ipi_id.AfterLoadDFMValues;
    Itens_EntradaDatasetcst_pis_id.AfterLoadDFMValues;
    Itens_EntradaDatasetcst_cofins_id.AfterLoadDFMValues;
    Itens_EntradaDatasetcsosn_id.AfterLoadDFMValues;
    Itens_EntradaDatasetorigem_csosn_id.AfterLoadDFMValues;
    Itens_EntradaDatasetquantidade_selo_ipi.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_base_issqn.AfterLoadDFMValues;
    Itens_EntradaDatasetissqn.AfterLoadDFMValues;
    Itens_EntradaDatasetcodigo_issqn.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_issqn.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_base_pis.AfterLoadDFMValues;
    Itens_EntradaDatasetpis.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_pis.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_base_cofins.AfterLoadDFMValues;
    Itens_EntradaDatasetcofins.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_cofins.AfterLoadDFMValues;
    Itens_EntradaDatasetcodigo_bc_piscofins_id.AfterLoadDFMValues;
    Itens_EntradaDatasetcodigo_credito_piscofins_id.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_base_st_retida.AfterLoadDFMValues;
    Itens_EntradaDatasetst_retida.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_st_retida.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_pis_retido.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_cofins_retido.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_desconto_nota.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_total_liquido.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_total_impostos.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_frete_por_fora.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_outras_despesas.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_preco_custo.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_preco_venda.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_icms_desonerado.AfterLoadDFMValues;
    Itens_EntradaDatasetdesoneracao_icms_id.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_icms_proprio_st.AfterLoadDFMValues;
    Itens_EntradaDatasetvalor_icms_original.AfterLoadDFMValues;
    Itens_EntradaDatasetplano_contas_contabil_id.AfterLoadDFMValues;
    Itens_EntradaDatasetcodigo_interno.AfterLoadDFMValues;
    Itens_EntradaDatasetexcluido.AfterLoadDFMValues;
    Itens_EntradaDatasetinclusao.AfterLoadDFMValues;
    Itens_EntradaDatasetalteracao.AfterLoadDFMValues;
    Itens_EntradaDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
  end;
end;

end.
